import { configureStore } from "@reduxjs/toolkit";
import userSlice from "../slice/userSlice";
import tokenSlice from "../slice/tokenSlice";
import appbarSlice from "../slice/appbarSlice";

const store = configureStore({
  reducer: {
    user: userSlice,
    token: tokenSlice,
    appbar: appbarSlice,
  },
});

export default store;
